import { endpoints, baseurl } from "../Utils/Constants";

export const getProviderIncentiveReport = async (
    token,
    organizationId,
    { providerName, startDate, endDate, cptCode, insurance, facility } = {},
) => {
    try {
        let url = baseurl + endpoints.GET_PROVIDER_INCENTIVE_REPORT + encodeURIComponent(organizationId || '');
        const params = new URLSearchParams();
        if (providerName) params.set('provider_name', providerName);
        if (startDate) params.set('start_date', startDate);
        if (endDate) params.set('end_date', endDate);
        if (cptCode && cptCode !== 'ALL') params.set('cpt_code', cptCode);
        if (insurance && insurance !== 'ALL') params.set('insurance', insurance);
        if (facility && facility !== 'ALL') params.set('facility', facility);
        const query = params.toString();
        if (query) url += `?${query}`;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching provider incentive report:", error);
        throw error;
    }
}
